import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // ALWAYS use dark theme - no toggle option
  const [theme] = useState('dark');

  useEffect(() => {
    // Always apply dark mode to document
    const root = document.documentElement;
    root.classList.add('dark');
    
    // Save to localStorage
    localStorage.setItem('flotto-theme', 'dark');
  }, []);

  const value = {
    theme: 'dark',
    toggleTheme: () => {}, // No-op function - theme is fixed
    isDark: true,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
